import { string, object, number } from 'yup';

const editUserRateSchema = object().shape({
  userId: string().required('The field Members is required'),
  rate: number().required('The field Rate is required'),
});

export default editUserRateSchema;
